import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Filters time slots based on EST timezone.
 * Removes past slots for today only.
 */
export const filterTimeSlots = (
  timeSlots: string[],
  selectedDate: string,
  tz: string = "America/New_York",
  leadBufferMinutes: number = 0
): string[] => {
  if (!Array.isArray(timeSlots) || !timeSlots.length) {
    return [];
  }

  const now = dayjs().tz(tz);
  const selected = dayjs.tz(selectedDate, "YYYY-MM-DD", tz);

  const isToday = selected.isSame(now, "day");

  // Future dates: return all slots without filtering
  if (!isToday) {
    return timeSlots;
  }

  const cutoffTime = now.add(leadBufferMinutes, "minute");

  // Today: remove past slots
  return timeSlots.filter((slot) => {
    let hour = 0;
    let minute = 0;

    const trimmed = slot.trim();
    if (/am|pm/i.test(trimmed)) {
      const match = trimmed.match(/(\d+):(\d+)\s*(AM|PM)/i);
      if (match) {
        let h = parseInt(match[1], 10);
        const m = parseInt(match[2], 10);
        const isPM = match[3].toUpperCase() === "PM";
        if (isPM && h < 12) h += 12;
        if (!isPM && h === 12) h = 0;
        hour = h;
        minute = m;
      }
    } else {
      const parts = trimmed.split(":").map(Number);
      hour = parts[0];
      minute = parts[1];
    }

    if (Number.isNaN(hour) || Number.isNaN(minute)) {
      return false;
    }

    const slotTime = selected
      .hour(hour)
      .minute(minute)
      .second(0)
      .millisecond(0);

    return slotTime.isAfter(cutoffTime);
  });
};